import $ from 'jquery';

export default function bind() {
  $('form:not(.no-loader)').on('submit', evt => {
    const inModal = $(evt.target).closest('.modal').length > 0;
    if (!inModal) {
      displayLoader();
    }

    return true;
  });

  $('form').on('reset', evt => {
    hideLoader();
    return true;
  });
}

export function displayLoader() {
  const $loader = $('#Loader');
  $loader.addClass('active');
}

export function hideLoader() {
  const $loader = $('#Loader');
  $loader.removeClass('active');
}



// WEBPACK FOOTER //
// ./src/plugins/loader.js